import React, { useEffect, useState } from "react"
import { Card, Col, Container, Row, CardBody } from "reactstrap"
import LoaderComponent from "components/loader"
import Breadcrumb from "components/Common/Breadcrumb"
import pdfIcon from "../../../assets/images/icons/file-type.svg"
import downloadIcon from "../../../assets/images/download.png"
import { useLazyGetAboutIcdQuery } from "store/api/investorapi/aboutUs"
import { useSelector } from "react-redux"

const AboutICD = () => {
  const [getResult, { isFetching }] = useLazyGetAboutIcdQuery()
  const { userType } = useSelector((state) => state.user)
  const [data, setData] = useState()
  const [docs, setDocs] = useState([])

  document.title = "About ICDs | Prachay"

  const getData = async () => {
    try {
      const { success, data } = await getResult({
        user_type: userType === "INVESTOR" ? "investor" : "wealthPartner",
      }).unwrap()
      if (success) {
        setData(data.aboutIcd)
        setDocs(data.docs)
      }
    } catch (error) {}
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={
              <>
                About ICD<small>s</small>
              </>
            }
          />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <div
                    style={{
                      maxHeight: docs.length > 0 ? "200px" : "auto",
                      overflowY: "auto",
                    }}
                  >
                    {isFetching ? (
                      <LoaderComponent />
                    ) : (
                      <div
                        className="dynamic-html-content"
                        dangerouslySetInnerHTML={{
                          __html: data?.value,
                        }}
                      />
                    )}
                  </div>
                </CardBody>
              </Card>
              {docs.length > 0 && (
                <Card>
                  <Breadcrumb title={"Documents"} />
                  <CardBody>
                    <div className="playlist-wrapper-section">
                      {docs.map((item, index) => (
                        <div
                          key={`document_${index}`}
                          className="playlist-card-box "
                        >
                          <div className="align-self-center text-center">
                            <img src={pdfIcon} alt="Download PDF" />
                          </div>
                          <p
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                              marginTop: "14px",
                              marginBottom: "14px",
                            }}
                          >
                            {item.title}
                          </p>

                          <div
                            style={{
                              textAlign: "center",
                              marginTop: "10px",
                              marginBottom: "14px",
                              fontWeight: "500",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                              color: "#09518C",
                            }}
                          >
                            <a
                              href={item.document_url}
                              className="d-flex flex-column play-icon"
                              download
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#09518C", fontSize: "16px" }}
                            >
                              Download
                            </a>
                            <img height={"20px"} src={downloadIcon} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AboutICD
